import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logo_light_new.png'
import _imports_1 from '@/assets/images/logo_dark.png'


_pushScopeId("data-v-311700fb")
const _hoisted_1 = {
  key: 0,
  class: "logo"
}
const _hoisted_2 = {
  key: 0,
  src: _imports_0,
  alt: "logo"
}
const _hoisted_3 = {
  key: 1,
  src: _imports_1,
  alt: "logo"
}
const _hoisted_4 = {
  key: 1,
  class: "content"
}
const _hoisted_5 = {
  key: 0,
  class: "checkout"
}
const _hoisted_6 = {
  key: 0,
  class: "info"
}
const _hoisted_7 = { class: "head" }
const _hoisted_8 = { class: "name" }
const _hoisted_9 = { class: "title" }
const _hoisted_10 = { class: "desc" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "status" }, [
  /*#__PURE__*/_createElementVNode("figure", null, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/images/safe.png",
      alt: "icon"
    })
  ])
], -1)
const _hoisted_12 = { class: "label" }
const _hoisted_13 = { class: "value" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { id: "flow-container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "loading" }, "Loading...")
], -1)
const _hoisted_15 = {
  key: 1,
  id: "myIframe",
  frameborder: "0",
  name: "myIframe",
  seamless: ""
}
const _hoisted_16 = ["action"]
const _hoisted_17 = ["value"]
const _hoisted_18 = ["value"]
const _hoisted_19 = ["value"]
const _hoisted_20 = ["value"]
const _hoisted_21 = ["value"]
const _hoisted_22 = ["value"]
const _hoisted_23 = ["value"]
const _hoisted_24 = ["value"]
const _hoisted_25 = ["action"]
const _hoisted_26 = ["value"]
const _hoisted_27 = {
  key: 2,
  class: "status"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("figure", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/images/29.png",
    alt: "png"
  })
], -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("p", null, "This page has been closed for security reasons.", -1)
const _hoisted_30 = [
  _hoisted_28,
  _hoisted_29
]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["iframe", [_ctx.theme]])
  }, [
    false
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (!['sunpaysandbox', 'sunpayprod'].includes(_ctx.dev))
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_ctx.theme === 'dark')
                  ? (_openBlock(), _createElementBlock("img", _hoisted_2))
                  : (_openBlock(), _createElementBlock("img", _hoisted_3))
              ]))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true),
    (!_ctx.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_ctx.actionType == 'COMPONENT')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (_ctx.kycInfo && false)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.kycInfo?.customer_name || "--"), 1),
                          _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.kycInfo?.customer_email || "--"), 1)
                        ]),
                        _hoisted_11
                      ]),
                      _createElementVNode("ul", null, [
                        _createElementVNode("li", null, [
                          _createElementVNode("div", _hoisted_12, [
                            (_ctx.kycInfo?.document_type)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode(_toDisplayString(_ctx.kycInfo?.document_type) + " - ", 1)
                                ], 64))
                              : _createCommentVNode("", true),
                            (_ctx.kycInfo?.document_number)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode(_toDisplayString(_ctx.kycInfo?.document_number), 1)
                                ], 64))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.kycInfo?.residence_country || "--"), 1)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_14
              ]))
            : (_openBlock(), _createElementBlock("iframe", _hoisted_15)),
          _createElementVNode("form", {
            id: "MyForm",
            ref: "LinkedPayForm",
            action: _ctx.FormData.checkoutUrl,
            method: "post",
            target: "myIframe"
          }, [
            _createElementVNode("input", {
              type: "hidden",
              name: "merchantNo",
              value: _ctx.FormData.merchantNo
            }, null, 8, _hoisted_17),
            _createElementVNode("input", {
              type: "hidden",
              name: "merOrderNo",
              value: _ctx.FormData.merOrderNo
            }, null, 8, _hoisted_18),
            _createElementVNode("input", {
              type: "hidden",
              name: "notifyUrl",
              value: _ctx.FormData.notifyUrl
            }, null, 8, _hoisted_19),
            _createElementVNode("input", {
              type: "hidden",
              name: "ipAddress",
              value: _ctx.FormData.ipAddress
            }, null, 8, _hoisted_20),
            _createElementVNode("input", {
              type: "hidden",
              name: "currencyCode",
              value: _ctx.FormData.currencyCode
            }, null, 8, _hoisted_21),
            _createElementVNode("input", {
              type: "hidden",
              name: "amount",
              value: _ctx.FormData.amount
            }, null, 8, _hoisted_22),
            _createElementVNode("input", {
              type: "hidden",
              name: "returnUrl",
              value: `${_ctx.FormData.syncNotifyUrl}`
            }, null, 8, _hoisted_23),
            _createElementVNode("input", {
              type: "hidden",
              name: "websiteUrl",
              value: `${_ctx.FormData.websiteUrl}`
            }, null, 8, _hoisted_24)
          ], 8, _hoisted_16),
          _createElementVNode("form", {
            ref: "NuveiForm",
            action: _ctx.FormData.checkoutUrl,
            method: "post",
            target: "myIframe"
          }, [
            _createElementVNode("input", {
              type: "hidden",
              id: "creq",
              name: "creq",
              value: _ctx.FormData.cReq
            }, null, 8, _hoisted_26)
          ], 8, _hoisted_25)
        ]))
      : _createCommentVNode("", true),
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_27, _hoisted_30))
      : _createCommentVNode("", true)
  ], 2))
}